import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import { addTrainer, resetPassword }from '../../../../../store/Actions/authActions/authActions'
import fbConfig from '../../../../../config/firebaseConfig'
import LinearProgress from '@material-ui/core/LinearProgress'
const uuidv4 = require('uuid/v4');
uuidv4();


const styles = theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: '48px'
    },
    margin: {
      margin: theme.spacing.unit,
    },
    input: {
        marginBottom: '24px',
      },
     submit: {
        paddingTop: '12px',
        paddingBottom: '12px',
        marginTop: '24px',
        marginBottom: '12px'
     } ,
    cssLabel: {
      '&$cssFocused': {
        color: 'red',
      },
    },
    cssFocused: {},
    cssUnderline: {
      '&:after': {
        borderBottomColor: 'red',
      },
    },
    cssOutlinedInput: {
      '&$cssFocused $notchedOutline': {
        borderColor: 'red',
      },
    },
    notchedOutline: {},
    bootstrapRoot: {
      'label + &': {
        marginTop: theme.spacing.unit * 3,
      },
    },
    bootstrapInput: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      border: '1px solid #ced4da',
      fontSize: 16,
      width: 'auto',
      padding: '10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
    bootstrapFormLabel: {
      fontSize: 18,
    },
    linearColorPrimary: {
      backgroundColor: 'transparent',
    },
    linearBarColorPrimary: {
      backgroundColor: 'white',
    },
  });


 class AddTrainerForm extends Component {
    constructor(props){
        super(props);
        this.state = {
          name: '',
          email: '',
          phone: '',
          companyId: sessionStorage.getItem('companyId'),
          trainerId: uuidv4(),
          message: '',
          role: 'trainer',
          loading: false
        }
      }
      handleChange = (e) => {
        //const email = event.target.value;
        this.setState({ 
            [e.target.name]: e.target.value,
            message: '',
            loading: false
         });
    }
    
   generatePassword() {
    var password = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";    
      for (var i = 0; i < 9; i++)
      password += possible.charAt(Math.floor(Math.random() * possible.length));
      this.setState({
        ...this.state,
        password: password
      })
    }
    handleSubmit = () => {
      this.setState({
        ...this.state,
        loading: true
      })
      let newTrainer = this.state
      const functions = fbConfig.functions();
      const addNewTrainer = functions.httpsCallable('addUser');
      addNewTrainer({ email: newTrainer.email,  companyId: this.state.companyId, name: this.state.name, phone: this.state.phone, trainerId: this.state.trainerId, role: this.state.role })
      .then(result => {
        this.setState({
          ...this.state,
          message: result.data.message,
          loading: false
        })
      }).then( ()=> {
        this.props.resetPassword({email:this.state.email})
        this.setState({
          ...this.state,
          messageResset: 'Email send to ' + this.state.email
        })
      })
       .catch(err => {
        //console.log(err);
          this.setState({
            ...this.state,
            message: err.message,
            loading: false
          })
      });
    }
    componentDidMount(){
       this.generatePassword()
    }
    render() {
        const { classes } = this.props;
        return (
          <div>
            <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmit}
                onError={errors => console.log(errors)} 
                className={classes.root}
                instantValidate
                id='trainerForm'
               >
               <TextValidator fullWidth
                    label="Trainers Name*"
                    className={classes.input}
                    onChange={this.handleChange}
                    name="name"
                    value={this.state.name}
                    validators={['required']}
                    errorMessages={['This field is required', 'Name is not valid']}
                />   
                <TextValidator fullWidth
                    label="Trainers Email*"
                    className={classes.input}
                    onChange={this.handleChange}
                    name="email"
                    value={this.state.email}
                    validators={['required', 'isEmail']}
                    errorMessages={['This field is required', 'Email is not valid']}
                />
                <TextValidator fullWidth
                    label="Trainers Phone"
                    className={classes.input}
                    onChange={this.handleChange}
                    name="phone"
                    value={this.state.phone}
                    validators={['isNumber']}
                    //validators={['minNumber:1', 'maxNumber:255', 'matchRegexp:^[0-9]$']}
                    errorMessages={'Phone is not valid'}
                />

                <Button 
                    type="submit"
                    fullWidth
                    variant="contained"
                    className={classes.submit}
                    style={{color: this.props.buttonColor, background: this.props.buttonBg}}
                >
                    Add Trainer
                </Button>
                <div style={{height: '20px', width:'100%', marginTop: '-14px'}}>
                { this.state.loading === true ? 
                  <LinearProgress 
                  classes={{
                  colorPrimary: classes.linearColorPrimary,
                  barColorPrimary: classes.linearBarColorPrimary,
                }} 
                style={{width: '100%'}}/>
                  : "" 
                }
              </div>
                </ValidatorForm>
                <div className="info">
                  <Typography  style={{width: '100%', textAlign: 'center'}} variant="overline" gutterBottom>
                  {this.state.message ? this.state.message : ''}</Typography> 
                  <Typography  style={{width: '100%', textAlign: 'center'}} variant="overline" gutterBottom>
                  {this.state.messageResset ? this.state.messageResset : ''}</Typography> 
                </div>
          </div>      
        )
    }
}
AddTrainerForm.propTypes = {
    classes: PropTypes.object.isRequired,
  };
export default withStyles(styles)(connect(null,{ addTrainer, resetPassword })(AddTrainerForm))